<form [formGroup]="form" #singleInNgForm="ngForm">
    <div class="grid sm:grid-cols-4 gap-3 w-full">
        <ng-container>
            <div class="col-span-4">
                <div class="p-4 bg-card shadow rounded overflow-hidden">
                    <mat-vertical-stepper [linear]="true" #horizontalStepper>
                        <mat-step [formGroupName]="'step1Upload'" [stepControl]="form.get('step1Upload')">
                            <ng-template matStepLabel>Loka / Opna Kríu</ng-template>
                            <p class="mt-1 mb-3 font-medium">
                                Vinsamlegast lokaðu
                                <strong>öllum eintökum</strong> af Kríu á tölvunni þinni. Í framhaldi skaltu opna aðeins
                                <strong>eitt nýtt</strong> eintak af Kríu.
                            </p>
                            <div class="flex">
                                <mat-checkbox [color]="'primary'" formControlName="check">
                                    Ég staðfesti að ég hafi lokað öllum eintökum af Kríu og í framhaldi opnað aðeins eitt nýtt eintak
                                </mat-checkbox>
                            </div>
                            <div class="flex justify-end mt-4">
                                <button
                                    class="px-8"
                                    mat-flat-button
                                    [color]="'primary'"
                                    [disabled]="form?.get('step1Upload')?.invalid"
                                    type="button"
                                    matStepperNext
                                >
                                    Næsta
                                </button>
                            </div>
                        </mat-step>
                        <mat-step [formGroupName]="'step2Upload'" [stepControl]="form.get('step2Upload')">
                            <ng-template matStepLabel>Stofna bréfaútskrift</ng-template>
                            <p class="mt-1 mb-3 font-medium">Vinsamlegast stofnaðu nýja bréfaútsrift í Kríu</p>
                            <div class="flex">
                                <mat-checkbox [color]="'primary'" (change)="listBrefLoggurHopar()" formControlName="check">
                                    Ég staðfesti að ég hafi stofnað nýja bréfaútskrift í Kríu
                                </mat-checkbox>
                            </div>
                            <div class="flex justify-end mt-4">
                                <button
                                    class="px-8"
                                    mat-flat-button
                                    [color]="'primary'"
                                    [disabled]="form?.get('step2Upload')?.invalid"
                                    type="button"
                                    matStepperNext
                                >
                                    Næsta
                                </button>
                            </div>
                        </mat-step>
                        <mat-step [formGroupName]="'step3Upload'" [stepControl]="form.get('step3Upload')">
                            <ng-template matStepLabel>Velja bréfaútskrift</ng-template>
                            <p class="mt-1 mb-3 font-medium">Veldu rétta bréfaútskrift hér að neðan</p>
                            @if (brefautskriftirHoparDropDown?.length == 0) {
                                <div class="col-span-4 fade-in-top">
                                    <span class="ml-2 text-md font-medium">Engin bréfútskrift fannst</span>
                                </div>
                            }
                            @if (brefautskriftirHoparDropDown?.length > 0) {
                                <div class="col-span-4 fade-in-top">
                                    <mat-form-field class="w-full">
                                        <mat-label>Bréfaútskrift</mat-label>
                                        <mat-select [formControlName]="'kriaHopurId'" (selectionChange)="brefaUtsriftSelect($event.value)">
                                            @for (hopur of brefautskriftirHoparDropDown; track hopur) {
                                                <mat-option [value]="hopur.dropDown.value">
                                                    <span [innerHTML]="hopur.dropDown.viewValue"></span>
                                                </mat-option>
                                            }
                                        </mat-select>
                                        @if (brefLoggurValinnHopur?.length > 0) {
                                            <mat-hint class="c-link text-right" (click)="viewDocumentDetailsList()"
                                                >Skoða bréfaútskrift ({{ brefLoggurValinnHopur?.length }})</mat-hint
                                            >
                                        }
                                    </mat-form-field>
                                </div>
                            }
                            <div class="flex justify-end mt-4">
                                <button
                                    class="px-8"
                                    mat-flat-button
                                    [color]="'primary'"
                                    [disabled]="form?.get('step3Upload')?.invalid"
                                    type="button"
                                    matStepperNext
                                >
                                    Næsta
                                </button>
                            </div>
                        </mat-step>
                        <mat-step [formGroupName]="'step4Upload'" [stepControl]="form.get('step4Upload')">
                            <ng-template matStepLabel>Opna skráarmöppu</ng-template>
                            <p class="mt-1 mb-3 font-medium">
                                Vinsamlegast afritaðu slóðina
                                <i class="break-all">{{ userDetails != null ? findKriaFolderPath() : '' }}</i>
                                og límdu inn í "File Explorer" á tölvunni þinni. Hér ætti ein mappa að birtast sem merkt er með raðnúmeri.
                                Vinsamlegast opnaðu möppuna sem merkt er með raðnúmeri.
                            </p>
                            <div class="flex">
                                <mat-checkbox [color]="'primary'" formControlName="check">
                                    Ég staðfesti að ég hafi fundið og opnað ofangreinda möppu (merkt með raðnúmeri)
                                </mat-checkbox>
                            </div>
                            <div class="flex justify-end mt-4">
                                <button
                                    class="px-8"
                                    mat-flat-button
                                    [color]="'primary'"
                                    [disabled]="form?.get('step4Upload')?.invalid"
                                    type="button"
                                    matStepperNext
                                >
                                    Næsta
                                </button>
                            </div>
                        </mat-step>
                        <mat-step [formGroupName]="'step5Upload'" [stepControl]="form.get('step5Upload')">
                            <ng-template matStepLabel>Hlaða inn skrám</ng-template>
                            <p class="my-6 font-medium">
                                Dragðu inn þær skrár sem fundust í raðnúmeramöppunni (sjá fyrra skref). Ef valið var .pdf skrár við myndun
                                bréfaútskriftar skal aðeins draga inn .pdf skrár.
                            </p>
                            <ngx-dropzone
                                class="custom-dropzone"
                                class="justify-center"
                                (change)="onSelect($event)"
                                [disabled]="form?.disabled"
                            >
                                <ngx-dropzone-label>
                                    <div>
                                        <h2>Velja eða draga inn bréfaútskrift (skrár)</h2>
                                        <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-preview>
                                    <ngx-dropzone-label>{{ files.length }} skrár valdar</ngx-dropzone-label>
                                </ngx-dropzone-preview>
                            </ngx-dropzone>
                            <div class="flex justify-end mt-4">
                                <button
                                    class="px-8"
                                    mat-flat-button
                                    [color]="'primary'"
                                    (click)="checkFilesAgainstKria(); checkIfPdfFiles()"
                                    type="button"
                                    matStepperNext
                                >
                                    Næsta
                                </button>
                            </div>
                        </mat-step>
                    </mat-vertical-stepper>
                </div>
            </div>
            @if (validFilesAgainstKria) {
                <documents-add-general-info
                    class="col-span-4"
                    formControlName="generalInfo"
                    [includeSystem]="false"
                    [includeDocumentDate]="false"
                ></documents-add-general-info>
            }
        </ng-container>
    </div>
    @if (validFilesAgainstKria) {
        <div class="flex items-center justify-end mt-[5px]">
            @if (form.dirty) {
                <button mat-stroked-button type="button" (click)="revertSingleDocAllChanges()" [disabled]="!formEnabled">
                    {{ 'label_cancel' | translate }}
                </button>
            }
            <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                @if (formEnabled) {
                    <span> Skrá bréfaútskrift ({{ brefLoggurValinnHopur?.length }}) </span>
                }
                @if (!formEnabled) {
                    <span>
                        <span class="float-left mt-[5px] mr-2"
                            >Skrái bréfaútskrift ({{ countCreateDoc | translocoDecimal }}/{{ brefLoggurValinnHopur?.length }})</span
                        >
                        <mat-progress-spinner class="float-left" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                    </span>
                }
            </button>
        </div>
    }
</form>
